<template>
  <div class="radius card bottom10px" :style="{borderRadius: '4px', padding:'1px'}">
    <el-tag :key="plan.orderId" class="auto-wrap" effect="light" >
      <el-text class="mx-1 value-font" type="primary">{{plan.packageName}}</el-text>
    </el-tag>
    <template v-if="plan.tradeId">
      <el-row class="card-row" :gutter="20" align="middle">
          <el-col :span="9" class="col-title">
            <el-text class="mx-1 ">{{getI18n('交易ID', 'tradeID')}}:</el-text>
          </el-col>
          <el-col :span="15">
            <el-text class="mx-1" type="primary">{{plan.tradeId}}</el-text>
          </el-col>
      </el-row>
    </template>
    <template v-if="plan.status!='Activated' && plan.status!='Expired'">
      <el-row class="card-row" :gutter="20" align="middle">
          <el-col :span="9" class="col-title">
            <el-text class="mx-1 ">{{getI18n('订购时间', 'Subscribed Time')}}:</el-text>
          </el-col>
          <el-col :span="15">
            <el-text class="mx-1" type="primary">{{convertUTC2LocalTime2(plan.createTime)}}</el-text>
          </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
          <el-col :span="9" class="col-title">
            <el-text class="mx-1"><span class="font-red">{{getI18n('最晚激活时间', 'Latest Activation Time')}}&nbsp;</span></el-text>
          </el-col>
          <el-col :span="15">
            <el-text class="mx-1" type="primary">{{convertUTC2LocalTime2(plan.endTime)}}</el-text>
          </el-col>
      </el-row>
    </template>
    <template v-else>
      <el-row class="card-row" :gutter="20" align="middle">
          <el-col :span="9" class="col-title">
            <el-text class="mx-1">{{getI18n('激活时间', 'Active Time')}}:</el-text>
          </el-col>
          <el-col :span="15">
            <el-text class="mx-1" type="primary">{{convertUTC2LocalTime2(plan.activeTime)}}</el-text>
          </el-col>
      </el-row>
      <el-row class="card-row" :gutter="20" align="middle">
          <el-col :span="9" class="col-title">
            <el-text class="mx-1">{{getI18n('过期时间', 'Expire Time')}}:</el-text>
          </el-col>
          <el-col :span="15">
            <span class="font-red">{{convertUTC2LocalTime2(plan.expireTime)}}</span>
          </el-col>
      </el-row>
    </template>
    <el-row class="card-row" :gutter="20" align="middle">
        <el-col :span="9" class="col-title">
          <el-text class="mx-1">{{getI18n('状态', 'Status')}}:</el-text>
        </el-col>
        <el-col :span="6">
          <el-text class="mx-1 value-font" type="primary">{{convertPackageStatus(plan)}}</el-text>
        </el-col>
        <el-col :span="9" class="col-button" v-if="plan.status!='Inactive' && plan.status!='Close'">
          <el-button plain @click="queryDataByPackage(plan.orderId)">
            <span type="success">{{getI18n('查询流量', 'Query Data')}}</span>
            <el-icon><ArrowDown v-if="!refIsExpand"/><ArrowUp v-if="refIsExpand" /></el-icon>
          </el-button>
        </el-col>
    </el-row>
    <!-- 第二层每个套餐的详情， 包括流量使用情况 -->
    <template v-if="refIsExpand && refUsage.code == 'ok'">
      <PacakgeDataCard :summaryData="refUsage.data.summaryData"/>
      <PackageDataDetailCard :historyQuota="refUsage.data.historyDailyData"/>
    </template>
  </div>
</template>

<script lang="ts">
import { ref, defineComponent, defineProps } from 'vue'
import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
import { apiPostData, getI18n, convertUTC2LocalTime2, isChinese } from '../utils'
import store from '../store'

import PacakgeDataCard from './PacakgeDataCard.vue'
import PackageDataDetailCard from './PackageDataDetailCard.vue'
export default defineComponent({
  name: 'PackageCard'
})
</script>

<script lang="ts" setup>
// eslint-disable-next-line
const props = defineProps({
  plan: {
    type: Object,
    require: true
  }
})

function convertPackageStatus (plan: object) {
  const statusMap = {
    Inactive: '未激活',
    Activated: '已激活',
    Close: '关闭',
    Expired: '过期'
  }

  if (isChinese()) {
    return statusMap[plan.status]
  }

  return plan.status
}

const refIsExpand = ref(false)
const refUsage = ref({ code: '' })
function queryDataByPackage (orderId: string) {
  refIsExpand.value = !refIsExpand.value
  if (!refIsExpand.value) {
    return
  }
  const data = { simNo: store.state.simInfo.data.simNo, orderId: orderId }
  apiPostData('/h5/v1/sim/order/query-usage', data)
    .then(data => {
      if (data !== null && data !== undefined) {
        refUsage.value = data
      }
    })
}
</script>

<style scoped>
.auto-wrap {
  width: 100%; /* 设置标签宽度 */
  white-space: normal; /* 允许换行 */
  height: auto;
  margin-bottom: 10px;
  font-size: 28px;
}
.col-button {
  text-align: right;
  padding-right: 20px !important;
}
</style>
